import { buildAuthenticatedWsUrl } from '../../../../shared/sockets';

export function buildInterveneChatSocketUrl(botNumber, organisationId = '') {
  const routeToken = botNumber || organisationId;
  if (!routeToken) return null;

  const normalizedBot = String(routeToken).trim();
  return buildAuthenticatedWsUrl(`/chat/${encodeURIComponent(normalizedBot)}/`);
}

export function buildInterveneStatusSocketUrl(botNumber, phoneNumber) {
  if (!botNumber || !phoneNumber) return null;
  return buildAuthenticatedWsUrl(`/message-status/${botNumber}/${phoneNumber}/`);
}
